export default (api) => ({
  fetch: (params) => api.$get("/instances", { params }),

  fetchOne: (id) => api.$get(`/instances/${id}`),

  create: (body) => api.$post("/instances", body),

  patch: (id, body) => api.$patch(`/instances/${id}`, body),

  remove: (id) => api.$delete(`/instances/${id}`),
});
